import React from "react";
import { AddNote } from "./AddNote";
import ChangePassword from "./ChangePassword";
import AddUser from "./AddUser";
import AddStudent from "./AddStudent";
import { LaunchOptions } from "./LaunchOptions";
import BulkLaunch from "./BulkLaunch/BulkLaunch";
import { SendToParentOptions } from "./SendToParentOptions";
import SelectLocation from "./SelectLocation/SelectLocation";
import { GetTriage } from "./GetTriage";
import UserGuide from "./UserGuide/UserGuide";
import { MakeAReferral } from "./MakeAReferral";
import { LaunchForOthers } from "./LaunchForOthers";
import ParentalConsent from "./ParentalConsent";
import AddCustomField from "./AddCustomField";
export interface ISlideInContent {
  id: string;
  header: string;
  content: React.ReactNode;
}

export const ADD_USER: ISlideInContent = {
  id: "ADD_USER",
  header: "Add User",
  content: <AddUser />,
};

export const CHANGE_PASSWORD: ISlideInContent = {
  id: "CHANGE_PASSWORD",
  header: "Change Password",
  content: <ChangePassword />,
};

export const ADD_NOTE: ISlideInContent = {
  id: "ADD_NOTE",
  header: "Add Note",
  content: <AddNote />,
};

export const ADD_STUDENT: ISlideInContent = {
  id: "ADD_STUDENT",
  header: "Add New Child",
  content: <AddStudent />,
};

export const LAUNCH_OPTIONS: ISlideInContent = {
  id: "LAUNCH_OPTIONS",
  header: "Launch Options",
  content: <LaunchOptions />,
};

export const SEND_TO_PARENT_OPTIONS: ISlideInContent = {
  id: "SEND_TO_PARENT_OPTIONS",
  header: "Resources for Parents",
  content: <SendToParentOptions />,
};
export const MAKE_A_REFERRAL: ISlideInContent = {
  id: "MAKE_A_REFERRAL",
  header: "Make a Referral",
  content: <MakeAReferral />,
}

export const SELECT_LOCATION: ISlideInContent = {
  id: "SELECT_LOCATION",
  header: "Change Location",
  content: <SelectLocation />
}

export const GET_TRIAGE: ISlideInContent = {
  id: "GET_TRIAGE",
  header: "Get Triage Report",
  content: <GetTriage />
}
export const BULK_LAUNCH: ISlideInContent = {
  id: "BULK_LAUNCH",
  header: "Bulk Launch",
  content: <BulkLaunch />
}

export const USER_GUIDES: ISlideInContent = {
  id: "USER_GUIDES",
  header: "User Guides",
  content: <UserGuide />
}

export const LAUNCH_FOR_OTHERS: ISlideInContent = {
  id: "LAUNCH_FOR_OTHERS",
  header: "Launch for Others",
  content: <LaunchForOthers />
}
export const PARENTAL_CONSENT: ISlideInContent = {
  id: "PARENTAL_CONSENT",
  header: "Parental Consent Needed",
  content: <ParentalConsent />
}
export const ADD_NEW_CUSTOMFIELD: ISlideInContent = {
  id: "ADD_NEW_CUSTOMFIELD",
  header: "Add New Custom Field",
  content: <AddCustomField />
}
export const contentTypes: ISlideInContent[] = [
  ADD_USER,
  CHANGE_PASSWORD,
  ADD_NOTE,
  LAUNCH_OPTIONS,
  ADD_NOTE,
];
